export enum LockPlacement {
    ON_THE_BRIDGE = 'ON_THE_BRIDGE',
    ON_THE_CLOUDS = 'ON_THE_CLOUDS'
}
